import { render, staticRenderFns } from "./myInfo.vue?vue&type=template&id=4f72ad42&scoped=true"
import script from "./myInfo.vue?vue&type=script&lang=js"
export * from "./myInfo.vue?vue&type=script&lang=js"
import style0 from "./myInfo.vue?vue&type=style&index=0&id=4f72ad42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72ad42",
  null
  
)

export default component.exports